import Swiper from "swiper";
import { gsap } from "gsap";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollToPlugin, ScrollTrigger);

// スムーススクロール
const smoothScroll = () => {
	const scrollTrigger = document.querySelectorAll('.js-smooth');

	for (let i = 0; i < scrollTrigger.length; i++) {
		scrollTrigger[i].addEventListener('click', ev => {
			ev.preventDefault();
			const navHeight = document.querySelector('header').clientHeight;
			const targetSection = scrollTrigger[i].getAttribute('href');

			const sectionAnchor = targetSection.split('#')[1] || '';
			const sectionElement = document.querySelector('#' + sectionAnchor);


			if (sectionElement) {
				const rect = sectionElement.getBoundingClientRect().top;
				const offset = window.pageYOffset;
				const gap = 20;
				const target = rect + offset - navHeight - gap;

				// 500ミリ秒遅延させる
				setTimeout(() => {
					gsap.to(window, 0.1, {
						scrollTo: { y: target },
						ease: 'power4.out',
					});
				}, 100);
			} else {
				window.location.href = targetSection;
			}
		});
	}
};


// headerのマージンを自動で付与する
const headerMargin = () => {
	const header = document.getElementById("header-height");
	const headerHeight = header.clientHeight;
	const body = document.querySelector("body");
	const addMargin = document.querySelectorAll(".header-margin-add");

	for (let i = 0; i < addMargin.length; i++) {
		addMargin[i].style.marginTop = headerHeight + "px";
	}
};

// ハンバーガーメニュー
const humMenu = () => {
	const menuBtn = document.getElementById("menu-btn");
	const menu = document.getElementById("menu");
	const headerBg = document.querySelector(".header-bg-top");

	menuBtn.addEventListener("click", () => {
		if (menuBtn.classList.contains("active")) {
			closeMenu();
		} else {
			openMenu();
		}
	});
	const anchorLinks = document.querySelectorAll("#menu a");
	anchorLinks.forEach(link => {
		link.addEventListener("click", () => {
			closeMenu();
		});
	});

	const openMenu = () => {
		menuBtn.classList.add("active");
		menu.classList.add("active");
		headerBg.classList.add("change");
	};
	const closeMenu = () => {
		menuBtn.classList.remove("active");
		menu.classList.remove("active");
		headerBg.classList.remove("change");
	};
};
// トップ施工事例スライダー
const topWorksSwiper = () => {
	const swiper = new Swiper(".top-works-slider", {
		loop: true,
		slidesPerView: 3,
		centeredSlides: true,
		spaceBetween: 20,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		breakpoints: {
			576: {
				slidesPerView: 1,
				centeredSlides: true,
			},
		},
	});
};

const worksCatSelect = () => {
	const btn = document.querySelector("#works-category-btn");
	const selectArea = document.querySelector("#works-category-area");

	if (btn) {
		btn.addEventListener("click", () => {
			if (btn.classList.contains("is_set")) {
				btn.classList.remove("is_set");
				selectArea.classList.remove("is_set");
			} else {
				btn.classList.add("is_set");
				selectArea.classList.add("is_set");
			}
		});
	}
};

// 施工事例詳細ページスライダー
const worksDetailSwiper = () => {
	const worksThumbnail = new Swiper(".works-thumbnail", {
		slidesPerView: 5,
		spaceBetween: 40,
		breakpoints: {
			576: {
				slidesPerView: 4,
				spaceBetween: 25,
			},
		},
		navigation: {
			nextEl: ".works-thumbnail-button-next",
			prevEl: ".works-thumbnail-button-prev",
		},
	});

	const slider = new Swiper(".works-detail-slider", {
		loop: false,
		slidesPerView: 2,
		centeredSlides: true,
		spaceBetween: 20,
		breakpoints: {
			768: {
				slidesPerView: 1,
				centeredSlides: true,
			},
		},
		thumbs: {
			swiper: worksThumbnail,
		},
	});
};

// スマホサイズでのフッターのお問い合わせエリアの高さを取得して付与する
const footerMargin = () => {
	const spContactArea = document.querySelector(".footer-contact-height");
	if (spContactArea) {
		const footerHeight = spContactArea.clientHeight;
		const addFooterMargin = document.getElementById("footer-margin-add");
		if (addFooterMargin) {
			addFooterMargin.style.marginBottom = footerHeight + "px";
		}
	}
};


window.addEventListener("DOMContentLoaded", () => {
	humMenu();
	worksCatSelect();
});

window.addEventListener("resize", () => {
	headerMargin();
	footerMargin();
});

window.addEventListener("load", () => {
	topWorksSwiper();
	worksDetailSwiper()
	headerMargin();
	footerMargin();
	smoothScroll();
});
